import Avatar from '@material-ui/core/Avatar';
import PlusIcon from '../../icons/Plus';
import React from 'react';
import useStyles from './Avatar.styles';
import { User } from '../../store/user/types';
import TrashCan from '../../icons/TrashCan';
import useTheme from '@material-ui/core/styles/useTheme';
import { useTranslation } from 'react-i18next';

export interface AvatarFormProps {
  user: User;
  save_handler: (avatar: File) => void;
  delete_handler: () => void;
}
const AvatarForm: React.FC<AvatarFormProps> = (props) => {
  const classes = useStyles();
  const fileInput = React.createRef<HTMLInputElement>();
  const { user, save_handler, delete_handler } = props;
  const { t, i18n } = useTranslation();

  const theme = useTheme();

  const on_input_handler = () => {
    if (fileInput.current?.files?.length) {
      const file = fileInput.current.files[0];
      save_handler(file);
    }
  };
  return (
    <div className="flex flex-col items-center">
      <Avatar
        alt={user.person.first_name}
        src={user.person.avatar_url ?? undefined}
        style={{ width: '6rem', height: '6rem' }}
      />
      <div className="flex items-center gap-x-8 mt-5  ">
        <div>
          <input
            accept="image/*"
            className={classes.input}
            id="icon-button-file"
            type="file"
            ref={fileInput}
            onInput={on_input_handler}
          />
          <label htmlFor="icon-button-file" className="flex items-center gap-x-2 cursor-pointer text-sm">
            <div>
              <PlusIcon />
            </div>
            <div style={{ color: theme.palette.primary.main }}>
              <span>Add image</span>
            </div>
          </label>
        </div>
        <div
          className="flex items-center gap-x-2 cursor-pointer text-sm"
          style={{ color: theme.palette.primary.main }}
          onClick={delete_handler}
        >
          <TrashCan stroke={theme.palette.primary.main} />
          <span>Delete image</span>
        </div>
      </div>
    </div>
  );
};

export default AvatarForm;
